import React from 'react'
import propTypes from 'prop-types'
import { Navigate, Outlet, useParams } from 'react-router-dom'
import { useAuth } from '../../../context/Auth'
import projects from '../../../assets/projects'

const ProtectedRoute = ({ redirectPath = '/', children }) => {
  const { currentUser } = useAuth()

  const params = useParams()
  const { projectId } = params

  // Returns a single matching project object
  const getProjectById = (id) => {
    const project = projects.filter((item) => item.url === id)
    return project[0]
  }

  // If there's a projectId, check if it's locked.
  // If there's NO projectId, this route is globally protected (like changelog), so it defaults to false (not allowed).
  const isAllowed = projectId ? (getProjectById(projectId)?.locked === false) : false

  // Redirects user when they're not signed in and not allowed
  if (!currentUser && !isAllowed) {
    return <Navigate to={redirectPath} replace />
  }

  return children ? children : <Outlet />
}

ProtectedRoute.propTypes = {
  redirectPath: propTypes.string,
  children: propTypes.shape(),
}

export default ProtectedRoute
